import UserAjax from '@ajax/user';

export function MentionCustomization(editor) {
  editor.conversion.for('upcast').elementToAttribute({
    view: {
      name: 'a',
      key: 'data-mention',
      classes: 'mention',
      attributes: {
        href: true,
        'data-tagged-user-id': true,
      },
    },
    model: {
      key: 'mention',
      value: (viewItem) => {
        // The mention feature expects that the mention attribute value
        // in the model is a plain object with a set of additional attributes.
        // In order to create a proper object, use the toMentionAttribute helper method:
        const mentionAttribute = editor.plugins.get('Mention').toMentionAttribute(viewItem, {
          // Add any other properties that you need.
          link: viewItem.getAttribute('href'),
          userId: viewItem.getAttribute('data-tagged-user-id'),
        });

        return mentionAttribute;
      },
    },
    converterPriority: 'high',
  });

  // Downcast the model 'mention' text attribute to a view <a> element.
  editor.conversion.for('downcast').attributeToElement({
    model: 'mention',
    view: (modelAttributeValue, { writer }) => {
      // Do not convert empty attributes (lack of value means no mention).
      if (!modelAttributeValue) {
        return;
      }

      return writer.createAttributeElement(
        'a',
        {
          class: 'mention',
          'data-mention': modelAttributeValue.id,
          'data-tagged-user-id': modelAttributeValue.userId,
          href: modelAttributeValue.link,
        },
        {
          // Make mention attribute to be wrapped by other attribute elements.
          priority: 20,
          // Prevent merging mentions together.
          id: modelAttributeValue.uid,
        }
      );
    },
    converterPriority: 'high',
  });
}

export function getFeedItems(queryText) {
  // Check if the query text meets the minimum character requirement
  // if (queryText.length < 1) {
  //   return [];
  // }

  const spaces = queryText.match(new RegExp(' ', 'g'));
  if (spaces && spaces.length > 1) {
    return [];
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      const items = fetchUsers();
      resolve(items);
    }, 300);
  });

  async function fetchUsers() {
    const response = await UserAjax.searchUsers(queryText, 0, window.commentsGroupId);
    return response.users.slice(0, 20).map((user) => {
      return {
        id: `@${user.name}`,
        userId: user.id,
        name: user.name,
        link: `/${user.username}`,
        username: user.username || '',
        avatar_url: user.avatar_url,
        verified: user.verified,
      };
    });
  }
}
